var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA000"
    },
    d: "M373.333,256c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 C432.214,234.596,479.93,186.881,480,128V42.667h-96c-5.891,0-10.667-4.776-10.667-10.667S378.109,21.333,384,21.333h106.667 c5.891,0,10.667,4.776,10.667,10.667v96C501.251,198.658,443.992,255.918,373.333,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA000"
    },
    d: "M138.667,256c-70.658-0.082-127.918-57.342-128-128V32c0-5.891,4.776-10.667,10.667-10.667H128 c5.891,0,10.667,4.776,10.667,10.667S133.891,42.667,128,42.667H32V128c0.071,58.881,47.786,106.596,106.667,106.667 c5.891,0,10.667,4.776,10.667,10.667C149.333,251.224,144.558,256,138.667,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA000"
    },
    d: "M322.709,425.131l-5.739-5.888C294.613,396.245,288.469,331.947,288,309.12 c-0.116-5.808-4.858-10.454-10.667-10.453h-42.667c-5.801-0.001-10.539,4.633-10.667,10.432 c-0.448,22.827-6.592,87.083-28.971,110.123l-5.739,5.888c-29.291,30.144-50.624,51.925-50.624,76.224 c0,5.891,4.776,10.667,10.667,10.667h213.333c5.891,0,10.667-4.776,10.667-10.667C373.333,477.035,352,455.253,322.709,425.131z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M384,0H128c-5.891,0-10.667,4.776-10.667,10.667v170.667C118.333,257.499,179.834,319,256,320 c76.166-1,137.667-62.501,138.667-138.667V10.667C394.667,4.776,389.891,0,384,0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.cc7c01b9f8ee92ea9e67cea872f9d6bb.svg";
export { ForwardRef as ReactComponent };